import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { APPLICATION_NAME } from 'app/app.constants';
import { AppState } from 'store/app-state';
import * as CartActions from 'store/cart/cart.actions';

@Component({
    selector: 'part-base',
    templateUrl: './part-base.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class PartBaseComponent {
  constructor(
    private store: Store<AppState>,
    title: Title,
    @Inject(APPLICATION_NAME) appName: string
  ) {
    title.setTitle(`${appName} - Parts`);
    this.store.dispatch(CartActions.getCartDataForBranchAndCustomer());
  }
}
